import { Logo } from "../../components/utils/logo";
import { NAV_LINKS } from "./landing-data";

const YEAR = new Date().getFullYear();

export function LandingFooter() {
  return (
    <footer className="border-t border-slate-800 bg-slate-950 py-12 text-slate-400">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo color="light" sizeClass="h-8" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed">
              Promang — drifts- og prosjektplattform for service-
              og entreprenørbedrifter.
            </p>
          </div>

          <nav
            className="flex flex-wrap gap-x-8 gap-y-2 text-sm"
            aria-label="Bunntekst"
          >
            {NAV_LINKS.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="transition hover:text-white"
              >
                {item.name}
              </a>
            ))}
            <a
              href="/authentication/login"
              className="transition hover:text-white"
            >
              Logg inn
            </a>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-8 text-xs sm:flex-row">
          <p>© {YEAR} Promang. Alle rettigheter reservert.</p>
          <p>Utviklet av <a href="https://primetek.no" target="_blank" rel="noopener noreferrer">Primetek AS.</a></p>
        </div>
      </div>
    </footer>
  );
}
